var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-lg-6 lbv-water-usage" },
    [
      _c("b-card", { attrs: { header: "Water Usage" } }, [
        _c("form", { staticClass: "form" }, [
          _c(
            "div",
            { staticClass: "form-row" },
            [
              _c(
                "label",
                {
                  staticClass: "col-form-label",
                  attrs: { for: "water-usage-date-from" },
                },
                [_vm._v("Date from")]
              ),
              _vm._v(" "),
              _c("b-form-input", {
                attrs: { id: "water-usage-date-from", type: "date" },
                on: { change: _vm.fromChangeHandler },
                model: {
                  value: _vm.from,
                  callback: function ($$v) {
                    _vm.from = $$v
                  },
                  expression: "from",
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "col-form-label",
                  attrs: { for: "water-usage-date-to" },
                },
                [_vm._v("Date to")]
              ),
              _vm._v(" "),
              _c("b-form-input", {
                attrs: { id: "water-usage-date-to", type: "date" },
                on: { change: _vm.toChangeHandler },
                model: {
                  value: _vm.to,
                  callback: function ($$v) {
                    _vm.to = $$v
                  },
                  expression: "to",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-row action" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.showReport.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n          Visualise Report\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.downloadReport.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n          Download Report\n        ")]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        { ref: "waterModal", attrs: { id: "waterUsage", "ok-only": "" } },
        [
          _c(
            "div",
            {
              staticClass: "header-wrapper",
              attrs: { slot: "modal-header" },
              slot: "modal-header",
            },
            [
              _c("h1", { staticClass: "water-pad" }, [
                _vm._v("\n        LeakBot ID: "),
                _c("span", [_vm._v(_vm._s(_vm.device_id))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "water-close water-pad" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.closeModal.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("X")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "water-download water-pad" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.downloadReport.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          Download\n        ")]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "water-form water-pad" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      attrs: { for: "water-usage-date-from" },
                    },
                    [_vm._v("Date from")]
                  ),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: { id: "water-usage-date-from-modal", type: "date" },
                    on: { change: _vm.fromChangeHandler },
                    model: {
                      value: _vm.from,
                      callback: function ($$v) {
                        _vm.from = $$v
                      },
                      expression: "from",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      attrs: { for: "water-usage-date-to" },
                    },
                    [_vm._v("Date to")]
                  ),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: { id: "water-usage-date-to-modal", type: "date" },
                    on: { change: _vm.toChangeHandler },
                    model: {
                      value: _vm.to,
                      callback: function ($$v) {
                        _vm.to = $$v
                      },
                      expression: "to",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary apply",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.showReport.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n          Apply\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "water-usage-wrapper",
              model: {
                value: _vm.waterUsage,
                callback: function ($$v) {
                  _vm.waterUsage = $$v
                },
                expression: "waterUsage",
              },
            },
            [
              _c(
                "table",
                [
                  _vm._l(_vm.waterUsage, function (day) {
                    return _c(
                      "tr",
                      [
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm._f("getFormattedDate")(day.message_timestamp)
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(day.water_usage, function (status) {
                          return _c("td", { staticClass: "water-status" }, [
                            _c("div", {
                              class: _vm._f("getUsageLabel")(status),
                            }),
                          ])
                        }),
                      ],
                      2
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "tr",
                    [
                      _c("td"),
                      _vm._v(" "),
                      _vm._l(_vm.timePoints, function (time) {
                        return _c("td", { staticClass: "timePoints" }, [
                          _vm._v(
                            "\n            " + _vm._s(time) + "\n          "
                          ),
                        ])
                      }),
                    ],
                    2
                  ),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "water-legend",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer",
            },
            [
              _c("div", { staticClass: "legend-holder" }, [
                _c("ul", [
                  _c("li", { staticClass: "use" }, [
                    _c("span", { staticClass: "color-box" }),
                    _vm._v("Water Use\n          "),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "no-use" }, [
                    _c("span", { staticClass: "color-box" }),
                    _vm._v("No Use\n          "),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "no-signal" }, [
                    _c("span", { staticClass: "color-box" }),
                    _vm._v("No Signal\n          "),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }